export const BUILD_VERSION = '1787253762';
